import { ClaimingStage } from '@app/api/models/claiming.models';
import { createAction, props } from '@ngrx/store';
import { FetchVerificationRequest, FetchVerificationResponse } from '@app/api/models/claiming.models';

export enum ClaimingActionTypes {
  FETCH_VERIFICATION_OPTIONS = '[FetchVerificationOptions] Fetch Verification Options',
  FETCH_VERIFICATION_OPTIONS_SUCCESS = '[FetchVerificationOptions] Fetch Verification Options Success',
  FETCH_VERIFICATION_OPTIONS_FAILURE = '[FetchVerificationOptions] Fetch Verification Options Failure',

  INIT_VERIFICATION = '[InitVerification] Init Verification',
  INIT_VERIFICATION_SUCCESS = '[InitVerification] Init Verification Success',
  INIT_VERIFICATION_FAILURE = '[InitVerification] Init Verification Failure',
  RESET_INIT_VERIFICATION_ERROR = '[InitVerification] Reset Init Verification Error',

  COMPLETE_VERIFICATION = '[CompleteVerification] Complete Verification',
  COMPLETE_VERIFICATION_SUCCESS = '[CompleteVerification] Complete Verification Success',
  COMPLETE_VERIFICATION_FAILURE = '[CompleteVerification] Complete Verification Failure',

  LOOKUP_REQUEST = '[LookupRequest] Lookup Request',
  LOOKUP_REQUEST_SUCCESS = '[LookupRequest] Lookup Request Success',
  LOOKUP_REQUEST_FAILURE = '[LookupRequest] Lookup Request Failure',

  MAC_USER_LOOKUP_REQUEST_ATTEMPT = '[Mac LookupRequest] Lookup Request Attempt',
  MAC_USER_LOOKUP_REQUEST_FAILURE = '[Mac LookupRequest] Lookup Request Failure',

  SET_CLAIMING_STAGE = '[SetClaimingStage] Set Claiming Stage',
  SET_LOOKUP_MADE_FLAG = '[SetLookupMadeFlag] Set Lookup Made Flag',

  MAXIMUM_ATTEMPTS_ERROR = '[CompleteVerification] Maximum Attempts Error',
  WRONG_VERIFICATION_CODE_ERROR = '[CompleteVerification] Wrong Verification Code Error',
  RETRY_FETCH_VERIFICATION_OPTIONS = '[RetryFetchVerificationOptions]  Retry Fetch Verification Options',

  CLOSE_CLAIMING_DIALOG = '[Claiming DIalog] Close Claiming Dialog',
  OPEN_CLAIMING_DIALOG = '[Claiming DIalog] Open Claiming Dialog',

  SET_OWNERSHIP_REQUESTED_ATTEMPT = '[Set Ownership Request Attempt] Set Ownership Requested Attempt',
  SET_OWNERSHIP_REQUESTED_SUCCESS = '[Set Ownership Request Success] Set Ownership Requested Success',
  SET_OWNERSHIP_REQUESTED_FAILURE = '[Set Ownership Request Failure] Set Ownership Requested Failure',

  CHECK_OWNERSHIP_STATUS = '[Check Ownership Status] Check Ownership Status',
  CLOSE_OWNERSHIP_STATUS = '[Close Ownership Status] Close Ownership Status',
}

export const fetchVerificationOptions = createAction(
  ClaimingActionTypes.FETCH_VERIFICATION_OPTIONS,
  props<{ id: string; payload: FetchVerificationRequest }>()
);

export const fetchVerificationOptionsSuccess = createAction(
  ClaimingActionTypes.FETCH_VERIFICATION_OPTIONS_SUCCESS,
  props<{ fecthResponse: FetchVerificationResponse }>()
);

export const fetchVerificationOptionsFailure = createAction(ClaimingActionTypes.FETCH_VERIFICATION_OPTIONS_FAILURE, props<{ error?: any }>());

export const initVerification = createAction(ClaimingActionTypes.INIT_VERIFICATION, props<{ id: string; payload: any }>());

export const initVerificationSuccess = createAction(ClaimingActionTypes.INIT_VERIFICATION_SUCCESS, props<{ payload?: any }>());

export const initVerificationFailure = createAction(ClaimingActionTypes.INIT_VERIFICATION_FAILURE, props<{ error?: any }>());

export const resetInitVerificationError = createAction(ClaimingActionTypes.RESET_INIT_VERIFICATION_ERROR);

export const completeVerification = createAction(ClaimingActionTypes.COMPLETE_VERIFICATION, props<{ establishmentId: string; payload?: any }>());

export const completeVerificationSuccess = createAction(ClaimingActionTypes.COMPLETE_VERIFICATION_SUCCESS, props<{ payload?: any }>());

export const completeVerificationFailure = createAction(ClaimingActionTypes.COMPLETE_VERIFICATION_FAILURE, props<{ payload?: any }>());

export const maximumAttemptsError = createAction(ClaimingActionTypes.MAXIMUM_ATTEMPTS_ERROR);

export const wrongVerificationCodeError = createAction(ClaimingActionTypes.WRONG_VERIFICATION_CODE_ERROR);

export const retryFetchVerification = createAction(ClaimingActionTypes.RETRY_FETCH_VERIFICATION_OPTIONS);

export const setClaimingStage = createAction(ClaimingActionTypes.SET_CLAIMING_STAGE, props<{ claimingStage: ClaimingStage; redirectUrl?: string }>());

export const lookUpRequest = createAction(ClaimingActionTypes.LOOKUP_REQUEST);

export const lookUpRequestSuccess = createAction(ClaimingActionTypes.LOOKUP_REQUEST_SUCCESS);

export const lookUpRequestFailure = createAction(ClaimingActionTypes.LOOKUP_REQUEST_FAILURE);

export const macLookUpRequest = createAction(ClaimingActionTypes.MAC_USER_LOOKUP_REQUEST_ATTEMPT);

export const macLookUpRequestFailure = createAction(ClaimingActionTypes.MAC_USER_LOOKUP_REQUEST_FAILURE);

export const setLookUpRequest = createAction(ClaimingActionTypes.SET_LOOKUP_MADE_FLAG, props<{ lookupRequested: boolean }>());

export const closeClaimingDialog = createAction(ClaimingActionTypes.CLOSE_CLAIMING_DIALOG);

export const openClaimingDialog = createAction(ClaimingActionTypes.OPEN_CLAIMING_DIALOG);

export const checkOwnershipStatus = createAction(ClaimingActionTypes.CHECK_OWNERSHIP_STATUS);

export const closeOwnershipStatus = createAction(ClaimingActionTypes.CLOSE_OWNERSHIP_STATUS);

export const setOwnershipRequested = createAction(ClaimingActionTypes.SET_OWNERSHIP_REQUESTED_ATTEMPT);

export const setOwnershipRequestedSuccess = createAction(ClaimingActionTypes.SET_OWNERSHIP_REQUESTED_SUCCESS, props<{ establishmentId: string }>());

export const setOwnershipRequestedFailure = createAction(ClaimingActionTypes.SET_OWNERSHIP_REQUESTED_FAILURE);
